
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue'
import { useWorkspaceStore } from '@/store/workspace'
import AuthModal from '@/views/Copilot/AuthModal.vue'
import TaskCenter from '@/views/Copilot/TaskCenter.vue'
import { changePassword } from '@/services/auth'

export default defineComponent({
  name: 'Workspace',
  components: { AuthModal, TaskCenter },
  emits: [],
  setup() {
    const store = useWorkspaceStore()
    // 备案期间隐藏支付宝购买入口（仅为前端展示开关，后端与支付逻辑保留）
    const alipayEnabled = false
    const fileInput = ref<HTMLInputElement | null>(null)
    const isDragging = ref(false)

    const triggerFileInput = () => {
      fileInput.value?.click()
    }

    const handleFileSelect = async (event: Event) => {
      const input = event.target as HTMLInputElement
      const files = Array.from(input.files || [])
      if (files.length > 0) await store.addFiles(files)
      input.value = ''
    }

    const handleDrop = async (event: DragEvent) => {
      isDragging.value = false
      if (!store.session) {
        store.showAuthModal()
        return
      }
      const files = Array.from(event.dataTransfer?.files || [])
      if (files.length > 0) await store.addFiles(files)
    }

    const formatSize = (bytes: number) => {
      if (bytes < 1024) return `${bytes} B`
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
      return `${(bytes / 1024 / 1024).toFixed(1)} MB`
    }

    const passwordModalVisible = ref(false)
    const oldPassword = ref('')
    const newPassword = ref('')
    const confirmPassword = ref('')
    const passwordMessage = ref('')
    const passwordSubmitting = ref(false)

    const submitPasswordChange = async () => {
      passwordMessage.value = ''
      if (newPassword.value.length < 8) {
        passwordMessage.value = '新密码至少 8 位'
        return
      }
      if (newPassword.value !== confirmPassword.value) {
        passwordMessage.value = '两次输入的新密码不一致'
        return
      }
      passwordSubmitting.value = true
      try {
        await changePassword(oldPassword.value, newPassword.value)
        passwordModalVisible.value = false
        oldPassword.value = ''
        newPassword.value = ''
        confirmPassword.value = ''
      }
      catch (e) {
        passwordMessage.value = e instanceof Error ? e.message : '修改失败'
      }
      finally {
        passwordSubmitting.value = false
      }
    }

    onMounted(() => {
      store.init()
      store.checkCouponCode()
    })
    onBeforeUnmount(() => store.stopPolling())

    return {
      store, alipayEnabled, fileInput, isDragging, triggerFileInput, handleFileSelect, handleDrop,
      formatSize,
      passwordModalVisible, oldPassword, newPassword, confirmPassword,
      passwordMessage, passwordSubmitting, submitPasswordChange,
    }
  },
})
